var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content intelligent-booking" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  lazy: true,
                  label: _vm.$t("CargoMsg.Cargo_PendingProvision"),
                  name: "pendingProvision"
                }
              },
              [
                _c("pending-provision", {
                  ref: "pendingProvision",
                  attrs: {
                    "tab-title": _vm.$t("CargoMsg.Cargo_PendingProvision")
                  }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  lazy: true,
                  label: _vm.$t("CargoMsg.Cargo_ProvisionHistory"),
                  name: "provisionHistory"
                }
              },
              [
                _c("provision-history", {
                  ref: "provisionHistory",
                  attrs: {
                    "tab-title": _vm.$t("CargoMsg.Cargo_ProvisionHistory")
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }